import getList from './getList';
import getIpmanagerSegmentipsIptype from './getIpmanagerSegmentipsIptype';
import getIpmanagerSegmentipsBroadcast from './getIpmanagerSegmentipsBroadcast';
import getChildSegmentipsList from './getChildSegmentipsList';
import getAllDatadictNetelement from './getAllDatadictNetelement';
import deleteIpSement from './deleteIpSement';
import postIpsSplit from './postIpsSplit';
import getIpmanageContracts from './getIpmanageContracts';
import getDomainListUnLogin from './getDomainListUnLogin';
import postIpsSplit2 from './postIpsSplit2';
import postAddIp from './postAddIp';
import getDetail from './getDetail';
import editIpSement from './editIpSement';
import getContractType from './getContractType';
import getContractUnit from './getContractUnit';
import postIpmanageContracts from './postIpmanageContracts';
import postIPmanageAttaches from './postIPmanageAttaches';
import deleteAttachesByUUUID from './deleteAttachesByUUUID';
import putIpmanageContracts from './putIpmanageContracts';
import deleteContracts from './deleteContracts';
import getNations from './getNations';
import getCitys from './getCitys';
import getNetelement from './getNetelement';
import getResourceType from './getResourceType';
import getIpmanagerAdd from './getIpmanagerAdd';
import getIpmanagerAddCommit from './getIpmanagerAddCommit';
export default {
  getList,
  getIpmanagerSegmentipsIptype,
  getIpmanagerSegmentipsBroadcast,
  getChildSegmentipsList,
  getAllDatadictNetelement,
  deleteIpSement,
  postIpsSplit,
  getIpmanageContracts,
  getDomainListUnLogin,
  postIpsSplit2,
  postAddIp,
  getDetail,
  editIpSement,
  getContractType,
  getContractUnit,
  postIpmanageContracts,
  postIPmanageAttaches,
  deleteAttachesByUUUID,
  putIpmanageContracts,
  deleteContracts,
  getNations,
  getCitys,
  getNetelement,
  getResourceType,
  getIpmanagerAdd,
  getIpmanagerAddCommit
};


// WEBPACK FOOTER //
// ./src/api/IPManage/index.ts